import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=4c4be8da&"
import script from "./EditForm.vue?vue&type=script&lang=ts&"
export * from "./EditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm})
